import { ImpulseElement, registerElement, target } from '@ambiki/impulse';
import type AwcAutocompleteElement from '@ambiki/impulse-view-components/dist/elements/autocomplete';

@registerElement('pay-rate-field')
export default class PayRateFieldElement extends ImpulseElement {
  @target() teammateContainer: HTMLElement;
  @target() teammateSelectField: AwcAutocompleteElement;

  toggleTeammateVisibility(event: Event) {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement)) return;

    // Make the teammate select visible and mark it as a `required` field.
    const userRate = radio.value === 'user';
    this.teammateContainer.hidden = !userRate;
    this.teammateSelectField.required = userRate;
  }
}
